import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const CheckBillingIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M13.9226 8.50527C14.248 8.17984 14.248 7.6522 13.9226 7.32676C13.5972 7.00132 13.0695 7.00132 12.7441 7.32676L8.33339 11.7374L7.256 10.6601C6.93057 10.3346 6.40293 10.3346 6.07749 10.6601C5.75206 10.9855 5.75206 11.5131 6.07749 11.8386L7.74413 13.5052C8.06957 13.8306 8.5972 13.8306 8.92264 13.5052L13.9226 8.50527Z"
          fill="#4DAC44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0001 1.66602C14.6025 1.66602 18.3334 5.39698 18.3334 9.99935C18.3334 14.6017 14.6025 18.3327 10.0001 18.3327C5.39771 18.3327 1.66675 14.6017 1.66675 9.99935C1.66675 5.39698 5.39771 1.66602 10.0001 1.66602ZM10.0001 3.33268C13.682 3.33268 16.6667 6.31745 16.6667 9.99935C16.6667 13.6812 13.682 16.666 10.0001 16.666C6.31818 16.666 3.33341 13.6812 3.33341 9.99935C3.33341 6.31745 6.31818 3.33268 10.0001 3.33268Z"
          fill="#4DAC44"
        />
      </svg>
    );
  }
);
export default CheckBillingIcon;
